import { Box, Button, IconButton, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { EasTableWithFilter } from 'ui/EasTableWithFilter';
import { ETableStructureType } from 'services/constants/tableStructureTypes';
import { useDispatch, useSelector } from 'react-redux';
import { PAGE_SIZE } from 'services/constants/env';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ESortDirection, TFilters } from 'services/constants/types';
import queryString from 'query-string';
import { DATES_ARRAY } from 'services/constants/dates';
import { DeleteDialog } from 'ui/DeleteDialog';
import { getShopGoodsList, getShopGoodsListIsLoad } from 'redux/reducers/shops/selectors';
import { getShopGoodsRequest } from 'redux/reducers/shops/reducer';
import { KeyboardBackspace } from '@mui/icons-material';
import { PATHS } from 'routes/constants';
import { getSavedUrl } from 'redux/reducers/auth/selectors';
import { deleteGoodsRequest } from 'redux/reducers/goods/reducer';
import { GoodsEditDialog } from './GoodsEditDialog';
import { tableStructure } from './tableStructure';
import { TGood } from './types';
// import goods from './data.json';

export const Goods: FC = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { search } = useLocation();
	const { shopId } = useParams<{ shopId: string }>();
	const navigateParams = queryString.parse(search);
	const { page } = queryString.parse(search);
	const goods = useSelector(getShopGoodsList);
	const goodsIsLoad = useSelector(getShopGoodsListIsLoad);
	const savedUrl = useSelector(getSavedUrl);
	const [openGoodsEditDialog, setOpenGoodsEditDialog] = useState(false);
	const [checkedIds, setCheckedIds] = useState<number[]>([]);

	const navigateParamsWithoutPage = tableStructure.reduce(
		(acc, item) => {
			if (item.type === ETableStructureType.DATE && navigateParams[item.selector]) {
				const dates = DATES_ARRAY.find((i) => i.id === navigateParams[item.selector]);
				if (dates?.from) {
					acc.push({
						fieldName: item.selector,
						value: dates.from,
						operator: '>=',
					});
				}
				if (dates?.to) {
					acc.push({
						fieldName: item.selector,
						value: dates.to,
						operator: '<=',
					});
				}
				return acc;
			}

			if (navigateParams[item.selector])
				acc.push({
					[item.selector]: navigateParams[item.selector] as string,
				});
			return acc;
		},
		[] as Array<{ [key: string]: string }>,
	);

	useEffect(() => {
		if (!shopId) return;
		setCheckedIds([]);

		const createdAt = DATES_ARRAY.find((i) => i.id === navigateParams.createdAt);
		const updatedAt = DATES_ARRAY.find((i) => i.id === navigateParams.updatedAt);

		dispatch(
			getShopGoodsRequest({
				shopId: +shopId,
				pageNumber: page ? +page : 1,
				pageSize: PAGE_SIZE,
				sortingField:
					navigateParams.sortIndex !== null
						? (tableStructure[+navigateParams.sortIndex]?.selector ?? 'createdAt')
						: 'createdAt',
				sortingDirection: navigateParams?.sortDirection
					? navigateParams.sortDirection === ESortDirection.DESC
						? ESortDirection.DESC
						: ESortDirection.ASC
					: ESortDirection.DESC,
				searchString: String(navigateParams?.search ?? ''),
				sku: (navigateParams?.sku as string) ?? null,
				hsCode: (navigateParams?.hsCode as string) ?? null,
				isActDisclosedAgent: String(navigateParams?.isActDisclosedAgent ?? 'all'),
				isReducedVatTbe: String(navigateParams?.isReducedVatTbe ?? 'all'),
				sellerRegistrationCountry: (navigateParams?.sellerRegistrationCountry as string) ?? null,
				goodType: (navigateParams?.goodType as string) ?? null,
				originatingCountry: (navigateParams?.originatingCountry as string) ?? null,
				warehouseLocationCountry: (navigateParams?.warehouseLocationCountry as string) ?? null,
				updatedByUser: (navigateParams?.updatedByUser as string) ?? '',
				createdAt: createdAt?.from ?? '',
				updatedAt: updatedAt?.from ?? '',
			}),
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, search]);

	const [openUploadSalesReport, setOpenUploadSalesReport] = useState(false);
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const handleDeleteGoods = () => {
		if (!shopId) return;
		dispatch(
			deleteGoodsRequest({
				body: { ids: checkedIds },
				requestGoods: {
					shopId: +shopId,
					pageNumber: page ? +page : 1,
					pageSize: PAGE_SIZE,
					sortingField:
						navigateParams.sortIndex !== null
							? (tableStructure[+navigateParams.sortIndex]?.selector ?? 'createdAt')
							: 'createdAt',
					sortingDirection: navigateParams?.sortDirection
						? navigateParams.sortDirection === ESortDirection.DESC
							? ESortDirection.DESC
							: ESortDirection.ASC
						: ESortDirection.DESC,
					searchString: String(navigateParams?.search ?? ''),
					sku: (navigateParams?.sku as string) ?? null,
					hsCode: (navigateParams?.hsCode as string) ?? null,
					isActDisclosedAgent: String(navigateParams?.isActDisclosedAgent ?? 'all'),
					isReducedVatTbe: String(navigateParams?.isReducedVatTbe ?? 'all'),
					sellerRegistrationCountry: (navigateParams?.sellerRegistrationCountry as string) ?? null,
					goodType: (navigateParams?.goodType as string) ?? null,
					originatingCountry: (navigateParams?.originatingCountry as string) ?? null,
					warehouseLocationCountry: (navigateParams?.warehouseLocationCountry as string) ?? null,
					updatedByUser: (navigateParams?.updatedByUser as string) ?? null,
					createdAt: (navigateParams?.createdAt as string) ?? null,
					updatedAt: (navigateParams?.updatedAt as string) ?? null,
				},
			}),
		);
		setCheckedIds([]);
		setOpenDeleteDialog(false);
	};

	// const handleAction = (id: number, typeOfDialog: string) => {
	// 	if (!id) return;

	// 	if (typeOfDialog === 'Delete Shop') {
	// 		setOpenDeleteDialog(true);
	// 	} else if (typeOfDialog === 'View Goods') {
	// 		navigate(`/shops/${id}/goods/`);
	// 	}
	// };

	// useEffect(() => {
	// 	if (!shopId) return;
	// 	dispatch(
	// 		getShopGoodsRequest({
	// 			pageNumber: page ? +page : 1,
	// 			pageSize: PAGE_SIZE,
	// 			shopId: +shopId,
	// 		}),
	// 	);
	// }, [dispatch, shopId, page]);

	const handleReplayHistory = () => {
		// window.history.back();
		if (savedUrl) {
			if (savedUrl.includes(PATHS.SHOPS_PAGE)) navigate(savedUrl);
			else navigate(PATHS.SHOPS_PAGE);
		}
	};

	return (
		<Box sx={{ margin: '0px 10px 0 10px' }}>
			<EasTableWithFilter<TGood>
				tableStructure={tableStructure}
				items={goods}
				itemsIsLoading={goodsIsLoad}
				// handleAction={handleAction}
				handleAction={() => {}}
				checkedIds={checkedIds}
				setCheckedIds={setCheckedIds}
			>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Box
						sx={{
							backgroundColor: 'primary.light',
							display: 'flex',
							justifyContent: 'start',
							alignItems: 'center',
							gap: '10px',
							cursor: 'pointer',
						}}
						onClick={handleReplayHistory}
					>
						<IconButton
							color="primary"
							sx={{
								p: '0',
							}}
						>
							<KeyboardBackspace />
						</IconButton>
						<Typography
							sx={{
								fontSize: '.9rem',
								color: 'primary.main',
								fontWeight: 'bold',
							}}
						>
							Goods {checkedIds.length > 0 ? ` - Selected ${checkedIds.length} goods` : ''}
						</Typography>
					</Box>
					<Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
						<Button
							variant="contained"
							color="primary"
							onClick={() => setOpenGoodsEditDialog(true)}
							size="small"
							disabled={checkedIds.length === 0}
						>
							Edit Selected Goods
						</Button>
						<Button
							variant="contained"
							color="primary"
							onClick={() => setOpenDeleteDialog(true)}
							size="small"
							disabled={checkedIds.length === 0}
						>
							Delete Selected Goods
						</Button>
					</Box>
				</Box>
			</EasTableWithFilter>

			<DeleteDialog
				open={openDeleteDialog}
				setClose={() => setOpenDeleteDialog(false)}
				handleDelete={handleDeleteGoods}
				text="Are you sure you want to delete selected goods?"
			/>
			<GoodsEditDialog
				open={openGoodsEditDialog}
				onClose={() => setOpenGoodsEditDialog(false)}
				ids={checkedIds}
			/>
		</Box>
	);
};
